import React, { useState, useRef } from 'react';

const RatingSlider = ({ value, onChange, min = 1, max = 6, tooltipLabel }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const trackRef = useRef(null);

  const fract = (value - min) / (max - min);
  const percentLeft = fract * 100;
  const thumbRadius = 10;
  const adjustment = (fract - 0.5) * 2 * -thumbRadius;
  const label = tooltipLabel ? tooltipLabel(value) : value;

  return (
    <span className="rating-slider__wrap">
      <input
        type="range"
        className="rating-slider"
        ref={trackRef}
        value={value}
        min={min}
        max={max}
        onChange={onChange}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onFocus={() => setShowTooltip(true)}
        onBlur={() => setShowTooltip(false)}
      />
      <div
        className={`rating-slider__tooltip ${showTooltip ? 'rating-slider__tooltip--on' : ''}`}
        style={{ left: `calc(${percentLeft}% + ${adjustment}px)` }}
      >
        <div className="rating-slider__tooltip__label">{label}</div>
        <div className="rating-slider__tooltip__arrow" />
      </div>
    </span>
  );
};

export default RatingSlider;
